import {useEffect, useState} from "react";
import {getTicketByUniqueCode} from "../../services/Administrative/ticketsService";

export const useGetTicketByUniqueCode = (uniqueCode:string) => {
    const [ticket, setTicket] = useState<any>(null);

    const updateTicketTechnicianLocally = (newTechnician : string, newServiceDate?: string) => {
        if (ticket) {
            setTicket({
                ...ticket,
                assignedTechnician: newTechnician,
                ...(newServiceDate !== undefined && { serviceDate: newServiceDate }),
            });
        }
    }

    const updateTicketBudgetLocally = (newBudget: any[]) => {
        if (ticket) {
            setTicket({
                ...ticket,
                budget: newBudget,
            });
        }
    }

    useEffect(() => {
        const fetchTicketByUniqueCode = async () => {
            try {
                const response = await getTicketByUniqueCode(uniqueCode);
                setTicket(response.ticket)
            } catch (error) {
                console.error('Error fetching filters:', error);
            }
        };
        fetchTicketByUniqueCode();
    }, []);

    return { ticket, updateTicketTechnicianLocally, updateTicketBudgetLocally };
};
